import { useCallback } from 'react'
import { toast } from 'react-toastify'
import { get } from 'lodash'

const useToasts = ({
    successMessage,
    errorMessage,
    onSuccess = () => {},
    onError = () => {},
} = {}) => {
    const success = useCallback((message) => {
        toast(successMessage || message)
        onSuccess(message)
    }, [onSuccess, successMessage])
    const error = useCallback((message) => {
        toast.error(errorMessage || message)
        onError(message)
    }, [onError, errorMessage])

    const apiError = (error) => {
        switch (get(error, 'status')) {
            case 403:
                toast.error(get(error, 'data', 'UNKNOWN 403'))
                break
            default:
                toast.error(`UNKNOWN ${get(error, 'status')}`)
        }
    }

    return {
        success,
        error,
        toastSuccess: success,
        toastError: error,
        apiError
    }
}

export default useToasts